import {ITheme} from 'contexts/ThemeContext';
import {Platform, useWindowDimensions} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return CreateResponsiveStyle(
    {
      containerStyle: {
        flexDirection: 'row',
        marginLeft: 30,
        marginTop: 20,
        marginBottom: 38,
      },
      tabButtonStyle: {
        flexDirection: 'row',
        marginRight: 5,
      },
      tabButtonLabelStyle: {
        fontSize: 14,
        lineHeight: 22,
        color: colors.silverChalice,
        ...typography.interRegular,
      },
      lastTabButtonLabelStyle: {
        fontSize: 14,
        lineHeight: 22,
        color: colors.primaryTextColor,
        ...typography.interRegular,
      },
      marginHorizontal: {
        marginLeft: 8,
        marginRight: 3,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
      [minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {},
    },
  )();
};
